export const brand = {
  name: "DropDex Alerts",
  domain: "dropdexalerts.app",
  colors: {
    navy: "#020327",
    gold: "#F5C400",
    green: "#35E47B",
    white: "#FFFFFF",
    muted: "#98A0B5"
  }
} as const;

export const supportedTcgs = [
  { id: "pokemon", name: "Pokémon", shortName: "Pokémon" },
  { id: "one-piece", name: "One Piece", shortName: "One Piece" },
  { id: "lorcana", name: "Disney Lorcana", shortName: "Lorcana" },
  { id: "gundam", name: "Gundam Card Game", shortName: "Gundam" },
  { id: "yu-gi-oh", name: "Yu-Gi-Oh!", shortName: "Yu-Gi-Oh!" },
  { id: "riftbound", name: "Riftbound", shortName: "Riftbound" },
  { id: "mtg", name: "Magic: The Gathering", shortName: "MTG" },
  { id: "union-arena", name: "Union Arena", shortName: "Union Arena" },
  { id: "dragon-ball-super", name: "Dragon Ball Super", shortName: "Dragon Ball" }
] as const;

export type TcgId = (typeof supportedTcgs)[number]["id"];

export const mobileNavigation = ["TCG", "News"] as const;
export const desktopNavigation = ["TCG Restocks", "Calendar", "Trending", "Smart Watchlist", "In-Store Restocks", "Notifications", "Discord", "News"] as const;

export const socialLinks = [
  { label: "X", href: "https://x.com/dropdexhq" },
  { label: "TikTok", href: "https://www.tiktok.com/@dropdexhq" },
  { label: "Instagram", href: "https://www.instagram.com/thedropdex" }
] as const;

export const contentStatuses = ["draft", "scheduled", "published", "archived"] as const;
export const alertStatuses = ["in-stock", "restocked", "preorder", "sold-out", "update"] as const;
export const deliveryChannels = ["push", "desktop", "in-app"] as const;

export const entitlements = {
  memberFeeds: "member_feeds",
  chat: "community_chat",
  portfolio: "desktop_portfolio",
  discord: "discord_community"
} as const;

export const featureFlags = {
  smsNotifications: false,
  browserMemberFeatures: false,
  portfolioMobile: false,
  mockCardCatalog: true,
  mockMarketPrices: true
} as const;

export const deepLinks = {
  content: "dropdex://content/:id",
  alert: "dropdex://tcg/:id",
  chat: "dropdex://chat/:messageId",
  portfolio: "dropdex://portfolio/:cardId",
  watchlist: "dropdex://watchlist/:itemId",
  trending: "dropdex://trending/:productKey"
} as const;

export const accountRoutes = [
  "/account/billing",
  "/account/discord",
  "/account/notifications"
] as const;
